import { ref, onUnmounted } from 'vue'
import { useImages } from './useImages.js'

// Composable für einfaches Bild-Loading mit Loading-State
export function useImageLoader() {
  const { loadOptimizedImage, revokeImageUrl } = useImages()
  
  const imageUrl = ref('')
  const isImageLoading = ref(false)
  const imageError = ref(null)
  let currentUrl = null
  
  const loadImage = async (imageId, width = 800, height = 600, format = 'webp', quality = 80) => {
    // Vorheriges Bild freigeben
    if (currentUrl) {
      revokeImageUrl(currentUrl)
      currentUrl = null
    }
    
    isImageLoading.value = true
    imageError.value = null
    imageUrl.value = ''
    
    try {
      const url = await loadOptimizedImage(imageId, width, height, format, quality)
      imageUrl.value = url
      currentUrl = url
    } catch (error) {
      console.error(`[useImageLoader] Failed to load image: ${imageId}`, error);
      imageError.value = error
      imageUrl.value = ''
    } finally {
      isImageLoading.value = false
    }
  }
  
  // Cleanup beim Unmount
  onUnmounted(() => {
    if (currentUrl) {
      revokeImageUrl(currentUrl)
    }
  })
  
  return {
    imageUrl,
    isImageLoading,
    imageError,
    loadImage
  }
}

// Composable für Hintergrundbild-Loading
export function useBackgroundImageLoader() {
  const { loadOptimizedBackgroundImage } = useImages()
  
  const backgroundStyle = ref('')
  const isBackgroundLoading = ref(false)
  const backgroundError = ref(null)
  
  const loadBackgroundImage = async (background_image, preset = 'background') => {
    isBackgroundLoading.value = true
    backgroundError.value = null
    backgroundStyle.value = ''

    try {
      const style = await loadOptimizedBackgroundImage(background_image, preset)
      backgroundStyle.value = style
    } catch (error) {
      console.error(`[useBackgroundImageLoader] Failed to load background image: ${background_image?.image}`, error);
      backgroundError.value = error
      backgroundStyle.value = ''
    } finally {
      isBackgroundLoading.value = false
    }
  }
  
  return {
    backgroundStyle,
    isBackgroundLoading,
    backgroundError,
    loadBackgroundImage
  }
}